<div>
        <div [height]="40"></div>

    <div [width]="260" [height]="420" style="display: flex; margin: 0 35px;">

        <div>
            <img-text [hint]="'ENTER_FIRST_NAME' | translate"
                      i18n-hint
                      [(ngModel)]="Details.FirstName"
                      (changeCaller)="onFirstNameChanged($event)"
                      i18n-label
                      [label]="'FIRST_NAME_POINT' | translate" [height]="58" [width]="250"
                      [fieldClass]="'large-field'"
                      [showImg]="false" testId="firstName"></img-text>

            <div [height]="15"></div>

            <img-text [hint]="'ENTER_LAST_NAME' | translate"
                      i18n-hint
                      [(ngModel)]="Details.LastName"
                      (changeCaller)="onLastNameChanged($event)"
                      [label]="'LAST_NAME_POINT' | translate" [height]="58" [width]="250"
                      i18n-label
                      [fieldClass]="'large-field'"
                      [showImg]="false" testId="lastName"></img-text>

            <div [height]="15"></div>

            <img-text *ngIf="!Details.IsPrivateUser"
                      [hint]="'ENTER_COMPANY_NAME' | translate"
                      i18n-hint
                      [(ngModel)]="Details.CompanyName"
                      (changeCaller)="onCompanyNameChanged($event)"
                      i18n-label
                      [label]="'COMPANY_NAME' | translate"
                      [height]="58"
                      [width]="250"
                      [fieldClass]="'large-field'"
                      [showImg]="false"
                      testId="company"
                      [maxlen]="200"></img-text>

            <div *ngIf="!Details.IsPrivateUser" [height]="15"></div>

            <img-text *ngIf="!Details.IsPrivateUser && Details.Country_HasVatID"
                      [hint]="'ENTER_VAT_ID' | translate"
                      i18n-hint
                      [(ngModel)]="Details.VatId"
                      (changeCaller)="onVatIdChanged($event)"
                      i18n-label
                      [label]="'VAT_ID' | translate" [height]="58" [width]="250"
                      [fieldClass]="'large-field'"
                      [showImg]="false" testId="vat"></img-text>

            <div *ngIf="!Details.IsPrivateUser && Details.Country_HasVatID" [height]="15"></div>

            <img-text [hint]="'ENTER_PHONE_NUMBER' | translate"
                      i18n-hint
                      [(ngModel)]="Details.Phone"
                      (changeCaller)="onPhoneChanged($event)"
                      i18n-label
                      [label]="'PHONE_NUMBER' | translate" [height]="58" [width]="250"
                      [fieldClass]="'large-field'"
                      [showImg]="false" testId="phone"></img-text>
        </div>

        <input style="width: 20px; border: 0">

        <div>
            <img-text [hint]="'ENTER_HOUSE' | translate"
                      i18n-hint
                      [(ngModel)]="Details.Address1"
                      (changeCaller)="onAddress1Changed($event)"
                      i18n-label
                      [label]="'ADDRESS_POINT' | translate" [height]="58" [width]="250"
                      [fieldClass]="'large-field'"
                      [showImg]="false" testId="house"></img-text>

            <div [height]="10"></div>

            <img-text [hint]="'ENTER_STREET' | translate"
                      i18n-hint
                      [(ngModel)]="Details.Address2"
                      (changeCaller)="onAddress2Changed($event)"
                      i18n-label
                      label="" [height]="40" [width]="250"
                      [fieldClass]="'large-field'"
                      [showImg]="false" testId="street"></img-text>

            <div [height]="40"></div>

            <img-text [hint]="'ENTER_CITY' | translate"
                      i18n-hint
                      [(ngModel)]="Details.City"
                      (changeCaller)="onCityChanged($event)"
                      i18n-label
                      [label]="'CITY_POINT' | translate" [height]="58" [width]="250"
                      [fieldClass]="'large-field'"
                      [showImg]="false" testId="city"></img-text>

            <div [height]="10"></div>

            <img-text [hint]="'ENTER_CODE' | translate"
                      i18n-hint
                      [(ngModel)]="Details.Zip"
                      (changeCaller)="onZipChanged($event)"
                      i18n-label
                      [label]="'ZIP_OR_POST_CODE' | translate" [height]="58" [width]="250"
                      [fieldClass]="'large-field'"
                      [showImg]="false" testId="postcode"></img-text>

            <div [height]="10"></div>

            <combo #countryCombo name="country" [autocomplete]="true"
                   [hint]="'CHOOSE_COUNTRY' | translate"
                   i18n-hint
                   [ComboData]="countries"
                   [(ngModel)]="Details.Country_ID"
                   [label]="'COUNTRY' | translate"
                   i18n-label
                   [height]="58"
                   [usePrevValue]="true"
                   (focusout)="onCountryFocusOut($event)"
                   (changeCaller)="onCountryChanged($event)"
                   [width]="250"
                   testId="country">
            </combo>

            <div [height]="10"></div>

            <img-text [hint]="'ENTER_STATE_PROVINCE' | translate"
                      i18n-hint
                      [(ngModel)]="Details.County"
                      (changeCaller)="onCountyChanged($event)"
                      i18n-label
                      [label]="'STATE_OR_PROVINCE' | translate" [height]="58" [width]="250"
                      [fieldClass]="'large-field'"
                      [showImg]="false" testId="province"></img-text>
        </div>
    </div>

    <div [height]="20"></div>
    <div class="bottomline"></div>
    <div [height]="10"></div>

    <simple-btn (click)="saveClick()"
            style="margin:auto"
            [width]="140"
            [backgroundFillCls]="'o2Background'"
            [hoverFillCls]="'o1Background'"
            [boxShadowCls]="'primary-shadow'"
            [disabled]="!HasChanges()"
            i18n-text
            [text]="'SAVE_CHANGES' | translate"
            [textCls]="'large-btn-text'"
            [height]="40"
            [cornerRadius]="50"
            [horizontalPadding]="20"
            data-testid="save">
    </simple-btn>
</div>
